<footer class="footer">
    <div class="container">

        <p class="text-muted text-center" style="font-size: 15px; color: #0088f2;">
            <a href="tel: 866-536-3459">Contact Us (877) 855 7493 </a>
            <a class="nav-link pt-3" href="mailto:servicing@resmac.com">servicing@resmac.com</a>
        </p>
        <div class="d-none d-lg-block">
        <p class="text-muted text-center" style="font-size: 10px;">
            © 2020 ResMac, Inc., dba LendingMan, a Florida corporation headquartered at 1500 Gateway Blvd, Suite 220, Boynton Beach, FL 33426, NMLS# 153098. LendingMan is an approved Seller/Servicer for Freddie Mac, FHA, Department of Housing and Urban Development, VA & USDA. LendingMan is an Equal Housing Lender committed to ensuring every applicant for credit receive fair and equal treatment throughout the credit application and approval process, as embodied in the Equal Credit Opportunity Act and the Fair Housing Act. All home lending products are subject to credit and property approval. Rates, program terms and conditions are subject to change without notice. Not all products are available in all states or for all amounts. Other restrictions and limitations apply. Applications received by any office or mortgage loan originator not licensed in a particular state will be referred to a mortgage loan originator who is licensed in the property state.
        </p>
        </div>
        <div class="row d-lg-none">
            <p class="text-muted text-center" style="font-size: 10px;">
                © 2020 ResMac, Inc. a Florida corporation headquartered at 1500 Gateway Blvd, Suite 220, Boynton Beach, FL 33426, NMLS# 153098.
            </p>
        </div>
    </div>
</footer>

